import { createApp } from "vue";
import App from "./App.vue";
import i18n from "./i18n";
import store from "./state/store";

import { VueQueryPlugin } from "@tanstack/vue-query";
import { createBootstrap } from "bootstrap-vue-next";
import { vMaska } from "maska";

import "bootstrap/dist/js/bootstrap";
import "vue-search-select/dist/VueSearchSelect.css";
import "flatpickr/dist/flatpickr.css";
import "vue-dadata/dist/vue-dadata.css";
import "@/assets/scss/config/saas/app.scss";

createApp(App)
  .use(i18n)
  .use(store)
  .use(createBootstrap({ components: true, directives: true }))
  .use(VueQueryPlugin)
  .directive("maska", vMaska)
  .mount("#app");
